import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/_authed/filenames/")({
  loader: () => {
    throw redirect({ to: "/filenames/game-titles" });
  },
});
